import { ridSegment } from '@krp/client-runtime'

/**
 * Адрес журнала обмена продажи с кабинетом AQSI (`AqsiSaleEndpoints`, `GET …/sales/{saleId}/exchanges`) через Gateway.
 * Литерал `/api/` законен только в файлах `api/urls.ts` (eslint).
 */
export const AQSI_EXCHANGE_URLS = {
  sale: (resourceId: string, saleId: string) =>
    `/api/aqsi/v1/resources/${ridSegment(resourceId)}/sales/${encodeURIComponent(saleId)}/exchanges`,
} as const
